import { createFileRoute } from "@tanstack/react-router";
import { SignUp } from "@clerk/clerk-react";
import instructorImage from "@/assets/instructor-sign-up.jpg";
import { Text } from "@mantine/core";
import { LegalConsentNotice } from "@/components/legal-consent-notice";
import { Page } from "@/components/page";
import { AuthLayout } from "./-components/auth-layout";

// const SignupSearchSchema = z.object({
//   productId: z.string().optional(),
// });
// export type SignupSearch = z.infer<typeof SignupSearchSchema>;

export const Route = createFileRoute("/_authenticate/sign-up/$")({
  // validateSearch: zodValidator(SignupSearchSchema),
  component: SignUpRouteComponent,
});

function SignUpRouteComponent() {
  // const { productId } = Route.useSearch();

  return (
    <Page title="Sign up">
      <AuthLayout image={instructorImage}>
        <Text mb="1rem" ml="0.5rem" c="pink.1" size="sm" maw="90vw">
          After you sign up you will be asked for your payment details.
        </Text>
        <SignUp
          path="/sign-up"
          routing="path"
          signInUrl="/sign-in"
          // unsafeMetadata={{ productId }}
        />
        <LegalConsentNotice />
      </AuthLayout>
    </Page>
  );
}
